module.exports = "<div class=\"sn-usc-store\" oncopy=\"return true;\" oncut=\"return true;\">\n  <usc-store-header></usc-store-header>\n\n  <usc-store-nav></usc-store-nav>\n  \n  <div #usc_store_view></div>\n\n  <usc-store-footer></usc-store-footer>\n  <sn-usc-notification notification_type=\"notification_deal_assignment\" class=\"usc-notify\"></sn-usc-notification>\n</div>  "


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-store.component.html
// module id = ../../../../../src/app/components/usc-store/usc-store.component.html
// module chunks = main